<!--
 * @Author: DY
 * @Date: 2021-02-23 10:45:43
 * @LastEditTime: 2021-10-13 17:39:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile_test\src\views\sso\login.vue
-->
<template>
    <div class="singleSignOn">
        <div class="head"></div>
        <div class="content">
            <h3>{{ newText }}</h3>
        </div>
        <div class="footer"></div>
    </div>
</template>

<script>

export default {
    // 单点登录中转页
    name: 'single-sign-on',
    components: {},
    props: {},
    data() {
        return {
            ticket: '',
            newText: '登录中。。。',
        };
    },
    computed: {},
    watch: {},
    created() {
        this.ticket = this.queryString(this.$route.fullPath, 'ticket');
        if (this.ticket) {
            this.getToken();
        } else {
            this.newText = '参数错误，ticket 缺失!';
        }
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 获取token
        async getToken() {
            await this.$axios
                .post('/interfaceApi/kingdee/SSO/jiyun/yunzhijia/login', { ticket: this.ticket })
                .then(res => {
                    sessionStorage.setItem('token', res.AccessToken);
                    sessionStorage.setItem('refreshToken', res.RefreshToken);
                    sessionStorage.setItem('clientID', this.guid);
                    this.$router.push({ path: '/' });
                })
                .catch(error => {
                    this.newText = error.ErrorCode.Message;
                });
        },
        // 字符串取值
        // eslint-disable-next-line consistent-return
        queryString(requestUrl, item) {
            if (requestUrl && requestUrl.length > 0) {
                const querys = requestUrl.split('&');
                const result = {};
                for (let i = 0; i < querys.length; i++) {
                    const temp = querys[i].split('=');
                    if (temp.length < 2) {
                        result[temp[0]] = '';
                    } else {
                        result[temp[0]] = temp[1];
                    }
                }
                if (item) {
                    return result[item];
                }
                return result;
            }
        },
    },
};
</script>
<style lang="stylus" scoped>
.singleSignOn
    width 100%
    height 100%
    .head
        width 100%
        height 124rpx
        background url(./images/login/head.png) center no-repeat
        background-size 100%
    .content
        width 100%
        height calc(100% - 334rpx)
        background url(./images/login/bg.png) center no-repeat
        background-size 100%
        h3
            color #979EA7
            font-size 20rpx
            text-align center
            width 100%
            position absolute
            bottom 25%
            text-align center
            padding 0 20rpx
    .footer
        width 100%
        height 210rpx
        background url(./images/login/footer.png) center no-repeat
        background-size 100%
</style>
